import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import {
  getDemurrage,
  submitDemurrageExtension,
  getDefoultPickuLocation,
  getAttachmentsOnlyDOExtension,
  getDoExtenstionDetails,
  fetchCFSNameByCountry,
  fetchEmptyYardNameByCountry,
  getDeliveryOrderDataForExtensionNew,
} from "../../../dashboard/actions/instruction";
import { getReleaseAttConfForExtension } from "../actions/Instruction";

interface IDemurrageForm {
  senderEmail: string | null;
  intendedDate: string | null;
  truckerCode: string | null;
  country: string | null;
  status: string | null;
  requestedPartnerName: string | null;
}

interface IDemurrageList {
  list: any[];
  next: string | null;
  previous: string | null;
}

interface IDemurrageDocAttachmentList {
  list: any[];
  next: string | null;
  previous: string | null;
}

// ─── Interfaces (Slice 2) ────────────────────────────────────────────────────

interface IDemurrageFormView {
  blId: any;
  senderEmail: string | null;
  country: string | null;
  intendedDate: string | null;
  remarks: string | null;
  userRemarks: string | null;
  status: string | null;
  list: any[];
  attList: any[];
  extensionAttList: any[];
  requestedPartnerName: string | null;
  requestedPartnerId: number | string | null;
  dndInstructionId: number | string | null;
  groupLevel: number;
  cfsName: string;
  emptyYardName: string;
  version?: number | null;
}

interface IDemurrageListView {
  list: any[];
  next: string | null;
  previous: string | null;
}

// ─── Combined State Interface ─────────────────────────────────────────────────

export interface IDemurrageDetails {
  // Slice 1 fields
  selectedTruckerCode: any;
  data: IDemurrageList;
  attData: IDemurrageDocAttachmentList;
  extensionAttData: IDemurrageDocAttachmentList;
  isDemurrageDetailsLoading: boolean;
  dataLoading: boolean;
  demurrageForm: IDemurrageForm;
  selectedDate: any;
  docList: any[] | null;
  version: number | null;
  extensionDocList: any[] | null;
  dropdownDocList: any[] | null;
  pickUpLocation: any[];
  truckerList: any[];
  selectedAttachmentName: any;
  selectedAttachmentBytrr: any;
  selectedAttachmentFilePath: any;
  selectedDocId: any;
  selectedPickupLocation: any;
  selectedCfsName: any;
  doExtensionRequestAllowed: boolean;
  cfsList: any[];
  emptyYardList: any[];
  selectedemptyYardName: any;
  selectedTruckerName: any;
  selectedtruckerId: any;
  selectedinternalCode: any;
  selectedDefaultPickupLocation: any;
  selectedFileServerPath: any;
  checkList: any;
  linerDocs: Array<any>;

  // Slice 2 fields
  dataView: IDemurrageListView;
  demurrageFormView: IDemurrageFormView;
}

// ─── Initial State ────────────────────────────────────────────────────────────

const initialState: IDemurrageDetails = {
  // ── Slice 1 ──
  data: {
    list: [],
    next: null,
    previous: null,
  },
  cfsList: [],
  emptyYardList: [],
  attData: {
    list: [],
    next: null,
    previous: null,
  },
  extensionAttData: {
    list: [],
    next: null,
    previous: null,
  },
  docList: null,
  extensionDocList: null,
  dropdownDocList: null,
  pickUpLocation: [],
  checkList: [],
  dataLoading: true,
  isDemurrageDetailsLoading: false,
  doExtensionRequestAllowed: false,
  demurrageForm: {
    senderEmail: "",
    intendedDate: "",
    truckerCode: "",
    country: "",
    status: "",
    requestedPartnerName: "",
  },
  selectedDate: {},
  selectedTruckerCode: {},
  selectedAttachmentName: {},
  selectedAttachmentBytrr: {},
  selectedDocId: {},
  selectedPickupLocation: {},
  selectedTruckerName: {},
  selectedtruckerId: {},
  truckerList: [],
  selectedinternalCode: {},
  selectedAttachmentFilePath: {},
  selectedDefaultPickupLocation: "",
  selectedFileServerPath: {},
  linerDocs: [],
  selectedCfsName: {
    label: null,
    value: 0,
  },
  selectedemptyYardName: {
    label: null,
    value: null,
  },
  version: null,

  // ── Slice 2 ──
  dataView: {
    list: [],
    next: null,
    previous: null,
  },
  demurrageFormView: {
    blId: null,
    senderEmail: "",
    intendedDate: "",
    status: "",
    remarks: "",
    userRemarks: "",
    country: "",
    list: [],
    attList: [],
    extensionAttList: [],
    requestedPartnerName: "",
    requestedPartnerId: null,
    dndInstructionId: null,
    groupLevel: 0,
    version: 0,
    cfsName: "",
    emptyYardName: "",
  },
};


export const DoExtensionSlice = createSlice({
  name: "doExtensionSlice",
  initialState,
  reducers: {
    updateDemurrageList: (state, action: PayloadAction<IDemurrageList>) => {
      state.data = action.payload;
    },
    clearPickupLocation: (state) => {
      const formattedData = {
        ...state.data,
        list: state.data.list.map((dt: any) => ({
          ...dt,
          pickupLocation: null,
        })),
      };
      state.data = formattedData;
    },
    updateDoExtensionRequestAllowed: (state, action: any) => {
      state.doExtensionRequestAllowed = action.payload;
    },
    updateSelectedDateDV: (state, action: PayloadAction<any>) => {
      state.selectedDate = action.payload;
    },
    updateSelectedtruckerCode: (state, action: PayloadAction<any>) => {
      state.selectedTruckerCode = action.payload;
    },
    updateSelectedAttachmentName: (state, action: PayloadAction<any>) => {
      state.selectedAttachmentName = action.payload;
    },
    updateSelectedAttachmentBytrr: (state, action: PayloadAction<any>) => {
      state.selectedAttachmentBytrr = action.payload;
    },
    updateSelectedDocId: (state, action: PayloadAction<any>) => {
      state.selectedDocId = action.payload;
    },
    updateAdttamentData: (state, action: PayloadAction<any>) => {
      state.attData.list = action.payload;
    },
    updateAttachmentDataForExtension: (state, action: PayloadAction<any>) => {
      state.extensionAttData.list = action.payload;
    },
    updateTruckerList: (state, action: PayloadAction<any>) => {
      state.truckerList = action.payload;
    },
    updateSelectedPickupLocation: (state, action: PayloadAction<any>) => {
      state.selectedPickupLocation = action.payload;
    },
    updateSelectedTruckerName: (state, action: PayloadAction<any>) => {
      state.selectedTruckerName = action.payload;
    },
    updateSelectedtruckerId: (state, action: PayloadAction<any>) => {
      state.selectedtruckerId = action.payload;
    },
    updateselectedInternalCode: (state, action: PayloadAction<any>) => {
      state.selectedinternalCode = action.payload;
    },
    updatePickupLocation: (state, action: PayloadAction<any>) => {
      state.pickUpLocation = action.payload;
    },
    updateSelectedAttachmentFilePath: (state, action: PayloadAction<any>) => {
      state.selectedAttachmentFilePath = action.payload;
    },
    updateSelectedCheckList: (state, action: PayloadAction<any>) => {
      const row = state.checkList.find(
        (item: any) => item.docId == action.payload.docId
      );
      if (row) {
        row.check = action.payload.check;
      }
    },
    updateselectedCheckListRemark: (state, action: PayloadAction<any>) => {
      const row = state.checkList.find(
        (item: any) => item.docId == action.payload.docId
      );
      if (row) {
        row.remarks = action.payload.remarks;
      }
    },
    clearSelectedFileServerPath: (state) => {
      state.selectedFileServerPath = {};
    },
    clearFields: (state) => {
      state.dropdownDocList = null;
      state.selectedAttachmentName = {};
      state.selectedAttachmentFilePath = {};
      state.selectedFileServerPath = {};
    },
    updateSelectedFileServerPath: (state, action: PayloadAction<any>) => {
      state.selectedFileServerPath = action.payload;
    },
    updateLinerVerify: (state, action: PayloadAction<any>) => {
      const row = state.extensionAttData.list.find(
        (Item) => Item.docId == action.payload.docId
      );
      if (row) {
        row.isVerify = action.payload.verify;
        row.fileName = action.payload.fileName;
        row.actionBy = action.payload.actionBy;
        row.actionOn = action.payload.actionOn;
      }
    },
    addDocument: (state, action) => {
      const { isExtension } = action.payload;
      if (!state.dropdownDocList || state.dropdownDocList.length === 0) return;

      const docListKey = isExtension ? "extensionDocList" : "docList";
      const attDataKey = isExtension ? "extensionAttData" : "attData";

      const rowNumber = crypto.randomUUID();
      const newDoc = { rowNumber: rowNumber, ...state.dropdownDocList[0] };

      state[docListKey] = [...(state[docListKey] ?? []), newDoc];

      state[attDataKey].list = [
        ...state[attDataKey].list,
        {
          rowNumber: newDoc.rowNumber,
          dndInstructionAttId: null,
          docId: newDoc.id,
          fileName: "",
          verify: false,
          actionBy: "",
          actionOn: "",
          m: newDoc.m,
          isDropDownDoc: true,
        },
      ];
    },
    removeDocument: (state, action) => {
      const { rowNumber, isExtension } = action.payload;
      const rowNumberToRemove = rowNumber;

      const docListKey = isExtension ? "extensionDocList" : "docList";
      const attDataKey = isExtension ? "extensionAttData" : "attData";

      state[docListKey] = (state[docListKey] ?? []).filter(
        (doc) => doc.rowNumber !== rowNumberToRemove
      );
      state[attDataKey].list = (state[attDataKey].list ?? []).filter(
        (att) => att.rowNumber !== rowNumberToRemove
      );

      const {
        [rowNumberToRemove]: removedName,
        ...restSelectedAttachmentName
      } = state.selectedAttachmentName ?? {};
      state.selectedAttachmentName =
        Object.keys(restSelectedAttachmentName).length > 0
          ? restSelectedAttachmentName
          : {};

      const {
        [rowNumberToRemove]: removedFilePath,
        ...restSelectedAttachmentFilePath
      } = state.selectedAttachmentFilePath ?? {};
      state.selectedAttachmentFilePath =
        Object.keys(restSelectedAttachmentFilePath).length > 0
          ? restSelectedAttachmentFilePath
          : {};

      const {
        [rowNumberToRemove]: removedServerPath,
        ...restSelectedFileServerPath
      } = state.selectedFileServerPath ?? {};
      state.selectedFileServerPath =
        Object.keys(restSelectedFileServerPath).length > 0
          ? restSelectedFileServerPath
          : {};
    },
    updateListByRowNumber: (state, action) => {
      const { rowNumber, updatedFields, isExtension } = action.payload;

      const docListKey = isExtension ? "extensionDocList" : "docList";
      const attDataKey = isExtension ? "extensionAttData" : "attData";

      const docList = state[docListKey];
      if (!docList) return;

      const docListIndex = (docList ?? []).findIndex(
        (doc) => doc.rowNumber === rowNumber
      );
      if (docListIndex !== -1) {
        docList[docListIndex] = {
          ...docList[docListIndex],
          ...updatedFields,
        };
      }

      if (state[attDataKey]?.list) {
        const attIndex = (state[attDataKey].list ?? []).findIndex(
          (att) => att.rowNumber === rowNumber
        );
        if (attIndex !== -1) {
          state[attDataKey].list[attIndex] = {
            ...state[attDataKey].list[attIndex],
            docId: updatedFields.id,
          };
        }
      }
    },
    updateSelectedCfsName: (state, action: PayloadAction<any>) => {
      state.selectedCfsName = action.payload;
    },
    updateSelectedemptyYardName: (state, action: PayloadAction<any>) => {
      state.selectedemptyYardName = action.payload;
    },
    setLinerAttachment: (state, action) => {
      const row = state.linerDocs.find((i) => i.docId == action.payload.docId);
      if (!row) return;
      Object.entries(action.payload).forEach(([key, val]) => {
        if (Object.hasOwn(row, key)) row[key] = val;
      });
    },
    resetDemurrageViewSlice: (state, action: any) => {
      state.demurrageFormView = initialState.demurrageFormView;
    },
    updateDemurrageListView: (state, action: PayloadAction<any>) => {
      state.dataView = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(submitDemurrageExtension.pending, (state) => {
      state.dataLoading = true;
    });
    builder.addCase(submitDemurrageExtension.fulfilled, (state) => {
      state.dataLoading = false;
    });
    builder.addCase(
      fetchCFSNameByCountry.fulfilled,
      (state, action: any) => {
        state.cfsList = action.payload;
        if (state.selectedCfsName?.value) {
          state.selectedCfsName.label =
            action.payload.find(
              (x: any) => x.value == state.selectedCfsName.value
            )?.label ?? null;
        }
        
      }
    );
    builder.addCase(
      fetchEmptyYardNameByCountry.fulfilled,
      (state, action: any) => {
        state.emptyYardList = action.payload;
        if (state.selectedemptyYardName?.value) {
          state.selectedemptyYardName.label =
            action.payload.find(
              (x: any) => x.value == state.selectedemptyYardName.value
            )?.label ?? null;
        }
      }
    );
    builder.addCase(getDefoultPickuLocation.pending, (state) => {
      state.dataLoading = true;
    });
    builder.addCase(getDefoultPickuLocation.fulfilled, (state, action) => {
      state.selectedDefaultPickupLocation =
        action?.payload?.toString() || "";
    });

    // ── getDemurrage ──────────────────────────────────────────────────────────
    builder.addCase(getDemurrage.pending, (state) => {
      state.data = { list: [], next: null, previous: null };
      state.dataLoading = true;
    });
    builder.addCase(getDemurrage.fulfilled, (state: any, action) => {
      state.dataLoading = false;
      state.data = action.payload;
    });

    builder.addCase(getDoExtenstionDetails.pending, (state) => {
      state.selectedemptyYardName.label = null;
      state.selectedemptyYardName.value = null;
      state.selectedCfsName.value = null;
      state.selectedCfsName.label = null;
      state.dataLoading = true;
    });
    builder.addCase(getDoExtenstionDetails.fulfilled, (state, action) => {
      state.dropdownDocList = action.payload.data?.dropdownDocList ?? [];
      state.extensionDocList = action.payload.data?.updatedDocListData ?? [];
      state.extensionAttData.list = action?.payload?.data?.extensionAttList || [];
      state.docList = action.payload.data?.updatedDocListData ?? [];
      state.attData.list = action?.payload?.data?.extensionAttList || [];
      state.version = action?.payload?.data?.version || null;
      state.checkList = action.payload.data?.checkList;
      state.linerDocs = (action.payload.data?.linerDocs ?? []).map(
        (x: any) => ({
          doReleasePdfId: x.doReleasePdfId,
          id: x.demurrageInstructionLinerAttId,
          name: x.docDesc,
          loading: 0,
          docId: x.docId,
          fileName: x.fileName ?? "",
          filePath: x.filePath ?? "",
          m: x.isMandatory == "Y",
          isRejected: x.isMandatory == "R",
          serverPath: null,
          tempName: null,
        })
      );
      state.selectedCfsName.value = action.payload.data.list.find(
        (x: any) => x.cfsPartnerId
      )?.cfsPartnerId;
      state.selectedCfsName.label =
        state.cfsList.find(
          (x) => x.value == state.selectedCfsName.value
        )?.label;
      state.selectedemptyYardName.value = action.payload.data.list.find(
        (x: any) => x.emptyYardPartnerId
      )?.emptyYardPartnerId;
      state.selectedemptyYardName.label =
        state.emptyYardList.find(
          (x) => x.value == state.selectedemptyYardName.value
        )?.label;

      state.dataLoading = false;
      state.demurrageFormView = {
        senderEmail: action?.payload?.data?.customerEmailId || "",
        remarks: action?.payload?.data?.remarks || "",
        userRemarks: action?.payload?.data?.userRemarks || "",
        country: action?.payload?.data?.country || "",
        status: action?.payload?.data?.status || "",
        intendedDate: new Date().toISOString(),
        list: action?.payload?.data?.list || [],
        requestedPartnerName:
          action?.payload?.data?.requestedPartnerNm || "",
        requestedPartnerId: action?.payload?.data?.requestedPartnerId ?? null,
        attList: action?.payload?.data?.extensionAttList || [],
        extensionAttList: action?.payload?.data?.extensionAttList || [],
        dndInstructionId:
          action?.payload?.data?.dndInstructionId || null,
        blId: action?.payload?.data?.blId,
        groupLevel: action?.payload?.data?.groupLevel ?? 0,
        cfsName: "",
        emptyYardName: "",
        version: action?.payload?.data?.version,
      };
    });
    builder.addCase(getDoExtenstionDetails.rejected, (state) => {});

    builder.addCase(getAttachmentsOnlyDOExtension.fulfilled, (state, action) => {
      state.dropdownDocList = action.payload?.dropdownDocList ?? [];
      if (action.payload?.att) {
        state.docList = action.payload?.updatedDocListData ?? [];
        state.attData.list = action.payload?.att || [];
        state.extensionDocList = action.payload?.updatedDocListData ?? [];
        state.extensionAttData.list = action.payload?.att || [];
        state.version = action.payload.version;
        if (action.payload?.chk) state.checkList = action.payload.chk;

        action.payload?.att?.forEach((data: any) => {
          const key =
            data?.dndInstructionAttId ?? data?.rowNumber ?? null;
          state.selectedAttachmentFilePath[key] = data.filePath;
          state.selectedAttachmentName[key] = { name: data.fileName };
        });
      }

      state.demurrageFormView.attList = [];
      state.demurrageFormView.extensionAttList = [];
      if (action?.payload?.id)
        state.demurrageFormView.dndInstructionId = action.payload.id;
      if (action?.payload?.status)
        state.demurrageFormView.status = action.payload.status;
      if (action?.payload?.level)
        state.demurrageFormView.groupLevel = action.payload.level;
      if (action.payload?.att) {
        state.demurrageFormView.attList = action.payload.att;
        state.demurrageFormView.version = action.payload.version;
        state.demurrageFormView.extensionAttList = action.payload.att;
      }
    });

    // builder.addCase(
    //   getDeliveryOrderDataForExtensionNew.fulfilled,
    //   (state, action) => {
    //     const deliveryOrder = (
    //       action?.payload?.dndInstructionAtt ?? []
    //     )?.find((doc: any) => doc.docId === 206);

    //     const existingDoc = (
    //       state.extensionAttData.list ?? []
    //     ).find((doc: any) => doc.docId == 309);

    //     existingDoc.fileName = deliveryOrder.fileName;
    //     existingDoc.filePath = deliveryOrder.filePath;

    //     state.selectedFileServerPath = {
    //       ...state.selectedFileServerPath,
    //       [existingDoc.rowNumber]: [
    //         existingDoc.filePath,
    //         existingDoc.fileName,
    //       ],
    //     };
    //     state.selectedAttachmentName = {
    //       ...state.selectedAttachmentName,
    //       [existingDoc.rowNumber]: { name: existingDoc.fileName },
    //     };
    //     state.selectedAttachmentFilePath = {
    //       ...state.selectedAttachmentFilePath,
    //       [existingDoc.rowNumber]: null,
    //     };

    //     state.extensionAttData.list = (
    //       state.extensionDocList ?? []
    //     )?.map((x: any) => ({
    //       rowNumber: x.rowNumber,
    //       dndInstructionAttId: null,
    //       docId: x.id,
    //       fileName: "",
    //       verify: false,
    //       actionBy: "",
    //       actionOn: "",
    //       m: x.m,
    //       ...(x.hasOwnProperty("isDropDownDoc")
    //         ? { isDropDownDoc: x.isDropDownDoc }
    //         : {})
    //     }));

    //     // action?.payload?.data?.extensionAttList?.forEach((data: any) => {
    //     //   const key = data?.dndInstructionAttId ?? data?.rowNumber ?? null;
    //     //   state.selectedAttachmentFilePath[key] = data.filePath;
    //     //   state.selectedAttachmentName[key] = { name: data.fileName };
    //     // });

    //     state.demurrageFormView.extensionAttList = [];
    //     // if (action.payload?.data?.extensionAttList) {
    //     //   state.demurrageFormView.extensionAttList =
    //     //     action.payload.data.extensionAttList;
    //     // }
    //   }
    // );

    builder.addCase(getReleaseAttConfForExtension.fulfilled, (state, action) => {
      // const updatedDocList = action?.payload?.data
      //   ?.filter(
      //     (i: any) => i.isMandatory != "H" && i.isMandatory != "E"
      //   )
      //   ?.map?.((i: any) => ({
      //     rowNumber: crypto.randomUUID(),
      //     id: i?.docId,
      //     name: i.docName,
      //     m: i.isMandatory == "Y",
      //   }));

      const updatedExtensionDocList = action?.payload?.data
        ?.filter((i: any) => (i.isMandatory != "H" && i.isMandatory != "E"))
        ?.map?.((i: any) => ({
          rowNumber: crypto.randomUUID(),
          id: i?.docId,
          name: i.docName,
          m: i.isMandatory == 'Y'
        }));

      const dropdownOptions = action?.payload?.data
        ?.filter((i: any) => i.isMandatory == "H")
        ?.map?.((i: any) => ({
          id: i?.docId,
          name: i.docName,
          m: true,
          isDropDownDoc: true,
        }));

      state.dropdownDocList = dropdownOptions ?? [];
      // state.docList = updatedDocList ?? [];
      state.extensionDocList = updatedExtensionDocList ?? [];

      // state.attData.list = (updatedDocList ?? [])?.map((x: any) => ({
      //   rowNumber: x.rowNumber,
      //   dndInstructionAttId: null,
      //   docId: x.id,
      //   fileName: "",
      //   verify: false,
      //   actionBy: "",
      //   actionOn: "",
      //   m: x.m,
      //   ...(x.hasOwnProperty("isDropDownDoc")
      //     ? { isDropDownDoc: x.isDropDownDoc }
      //     : {}),
      // }));

      state.extensionAttData.list = (updatedExtensionDocList ?? [])?.map(
        (x: any) => ({
          rowNumber: x.rowNumber,
          dndInstructionAttId: null,
          docId: x.id,
          fileName: "",
          verify: false,
          actionBy: "",
          actionOn: "",
          m: x.m,
          ...(x.hasOwnProperty("isDropDownDoc")
            ? { isDropDownDoc: x.isDropDownDoc }
            : {}),
          // ...(x.hasOwnProperty("isDOExtensionFile")
          //   ? { isDOExtensionFile: x.isDOExtensionFile }
          //   : {}),
        })
      );

 
        const deliveryOrder = (
          action?.payload?.existingDoRequest?.dndInstructionAtt ?? []
        )?.find((doc: any) => doc.docId == 206);

        const existingDoc = (
          state.extensionAttData.list ?? []
        ).find((doc: any) => doc.docId == 309);

        if (deliveryOrder && existingDoc){

      
        existingDoc.fileName = deliveryOrder.fileName;
        existingDoc.filePath = deliveryOrder.filePath;

        state.selectedFileServerPath = {
          ...state.selectedFileServerPath,
          [existingDoc.rowNumber]: [
            existingDoc.filePath,
            existingDoc.fileName,
          ],
        };
        state.selectedAttachmentName = {
          ...state.selectedAttachmentName,
          [existingDoc.rowNumber]: { name: existingDoc.fileName },
        };
        state.selectedAttachmentFilePath = {
          ...state.selectedAttachmentFilePath,
          [existingDoc.rowNumber]: null,
        };

        // state.extensionAttData.list = (
        //   state.extensionDocList ?? []
        // )?.map((x: any) => ({
        //   rowNumber: x.rowNumber,
        //   dndInstructionAttId: null,
        //   docId: x.id,
        //   fileName: "",
        //   verify: false,
        //   actionBy: "",
        //   actionOn: "",
        //   m: x.m,
        //   ...(x.hasOwnProperty("isDropDownDoc")
        //     ? { isDropDownDoc: x.isDropDownDoc }
        //     : {})
        // }));

        // action?.payload?.data?.extensionAttList?.forEach((data: any) => {
        //   const key = data?.dndInstructionAttId ?? data?.rowNumber ?? null;
        //   state.selectedAttachmentFilePath[key] = data.filePath;
        //   state.selectedAttachmentName[key] = { name: data.fileName };
        // });

        // state.demurrageFormView.extensionAttList = [];
        // if (action.payload?.data?.extensionAttList) {
        //   state.demurrageFormView.extensionAttList =
        //     action.payload.data.extensionAttList;
        // }
        }
      
  

    });
  },
});

export const {
  updateDemurrageList,
  updateSelectedDateDV,
  updateSelectedtruckerCode,
  updateSelectedAttachmentBytrr,
  updateSelectedAttachmentName,
  updateSelectedDocId,
  updateAdttamentData,
  updateAttachmentDataForExtension,
  updateSelectedPickupLocation,
  updateSelectedTruckerName,
  updateSelectedtruckerId,
  updateDoExtensionRequestAllowed,
  updateselectedInternalCode,
  updatePickupLocation,
  updateSelectedAttachmentFilePath,
  updateSelectedFileServerPath,
  clearSelectedFileServerPath,
  addDocument,
  removeDocument,
  clearFields,
  updateListByRowNumber,
  updateLinerVerify,
  updateSelectedCheckList,
  updateselectedCheckListRemark,
  setLinerAttachment,
  updateSelectedCfsName,
  updateSelectedemptyYardName,
  clearPickupLocation,
  resetDemurrageViewSlice,
  updateDemurrageListView,
} = DoExtensionSlice.actions;

export default DoExtensionSlice.reducer;